import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import {
  CarouselLeftArrow,
  CarouselLeftArrowDisable,
  CarouselRightArrow,
  CarouselRightArrowDisable,
} from 'assets/newIcons';
// import dummyData from '../dummyData';
import { CircularProgress } from '@material-ui/core';
import EmptyCard from '../../EmptyCard';

const DesktopVisual = ({
  userPackagesData,
  userPackagesMessage,
  isPackagesLoading
}) => {
  const [position, setPosition] = useState(0);

  const handleNext = () => {
    if (totalCards <= 3) {
      return;
    } else {
      setPosition(position + 1);
    }
  };

  const handlePrev = () => {
    setPosition(position - 1);
  };


  const totalCards = userPackagesData?.length;
  const isAtFirstCard = position === 0;
  const isAtLastCard = position === totalCards - 1;
  return (
    <div className={styles.child}>
      {isPackagesLoading ? (
        <CircularProgress size={50} style={{ color: '#FE5000', marginTop: '50px' }} />
      ) : userPackagesData !== null ? (
        <>
          <div
            className={`${styles.carouselContainer} ${
              totalCards <= 3 ? styles.adjustWidth : ''
            }`}
          >
            <div
              className={styles.carousel}
              style={{ transform: `translateX(${-position * 330}px)` }}
            >
              {userPackagesData?.map((data, index) => {
                return (
                  <div className={styles.card}>
                    <div className={styles.cardSubContainer1}>
                      <Text className={styles.cardHeading}>{data.name}</Text>
                      <Text className={styles.cardSubHeading}>{data.quantity}</Text>
                    </div>
                    <div className={styles.cardSubContainer2}>
                      <div className={styles.circle}>{data.remainingCount}</div>
                      <Text className={styles.cardContent}>Remaining</Text>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.paginationControls}>
            <img
              alt=""
              width={40}
              height={40}
              src={isAtFirstCard ? CarouselLeftArrowDisable : CarouselLeftArrow}
              onClick={() => (isAtFirstCard ? null : handlePrev())}
              className={styles.img}
              style={isAtFirstCard ? { cursor: 'unset' } : { cursor: 'pointer' }}
            />

            <img
              alt=""
              width={40}
              height={40}
              style={
                isAtLastCard || totalCards <= 3
                  ? { cursor: 'unset' }
                  : { cursor: 'pointer' }
              }
              className={styles.img}
              src={
                isAtLastCard || totalCards <= 3
                  ? CarouselRightArrowDisable
                  : CarouselRightArrow
              }
              onClick={() => (isAtLastCard ? null : handleNext())}
            />
          </div>
        </>
      ) : (
        <EmptyCard message={userPackagesMessage} />
      )}
    </div>
  );
};

export default DesktopVisual;
